import { styled } from "styled-components";
import { UploadPhotoWrapper, UploadPhotoIcon, InputFile, EditIcon, CloseIcon, IconWrapper, AgentDetailsInputGroup} from "../../components/agent";
import { useContext, useEffect, useState } from "react";
import { US_STATES } from "../../constants/common";
import { MainContext } from "../../context";
import { Modal, ModalBody, ModalFooter, ModalHeader, Button, Form } from "react-bootstrap";
import { Loader } from "../../components/loader";
import { FieldErrorMessage } from "./addagent";
import isValidUrl from '../../utils/isValidUrl';
import { AGENT_PROFILE_URL } from '../../constants/common';
import Select from 'react-select';
import { getOfficers } from "../../services/admin";
import { debounce } from 'lodash';

import { 
    AddCommunityContainer,
    HeroAndCommunityNameWrapper,
    HeroWrapper,
    HeroLeftCol,
    HeroRightCol,
    UploadPhoto,
    HeroRightColImage,
    HeroRightColImages,
    CommunityNameWrapper,
    CommunityNameDetailsWrapper,
    CommunityNameDetails,
    CommunityByWrapper,
    QuickFactsContentWrapper,
    QuickFactsLeftCol,
    QuickFactsRightCol,
    QuickFactsRightColDetails,
    QuickFactsTextDetails,
    QuickFactsWrapper,
    FactsCard,
    FactsCard160,
    FactsCardIconWrapper,
    FactsCardTextContentWrapper,
    HighlightsWrapper,
    HighlightIcon,
    SectionHeader,
    SectionDetails,
    SectionDetailsLeftCol,
    SectionDetailsText,
    SectionDetailsRightCol,
    HomesButton,
    SectionGallery,
    SectionGalleryImage,
    SectionGalleryWrapper,
    SectionGalleryImages,
    SectionGalleryMediaWrapper,
    SectionGalleryUploadImage,
    SectionGalleryUploadImageWrapper,
    SectionGalleryUploadWrapper,
    SectionGalleryVideo,
    MediaPreview,
    SectionBuilderDescriptionWrapper,
    SectionBuilderDetailsContainer,
    SectionBuilderDetailsContent,
    SectionBuilderDetailsContentLeftCol,
    SectionBuilderDetailsContentRightCol,
    SectionBuilderDetailsContentText,
    SectionBuilderDetailsContentWrapper,
    SectionBuilderDetailsWrapper,
    SectionBuilderLogoWrapper,
    SectionAgentContainer,
    SectionAgentContentWrapper,
    SectionAgentDetailsContainer,
    SectionAgentDetailsTextFieldColWrapper,
    SectionAgentDetailsTextFieldWrapper,
    SectionAgentDetailsTextFieldWrapperText,
    SectionAgentDetailsWrapper,
    SectionAgentForm,
    SectionAgentFormField,
    SectionAgentFormFieldText,
    SectionAgentLeftCol,
    SectionAgentRightCol,
    SectionAgentWrapper,
    CustomHighlightsContent,
    CustomHighlightPhoto,
    CustomHighlightTextFieldGroup
 } from "./addCommunity";
import { Link } from "react-router-dom";

export const EmbedUrlForm = styled.div`
  z-index: 5;
	width: 100%;
	display: flex;
	flex-direction: row;
	align-items: center;
	border-width: 1px 0px 0px 0px;
	border-style: solid;
	border-color: #d8d8d8;

	p {
 		display: flex;
		justify-content: center;
		width: 30%;
		font-size: 15px;
		padding: 5px;
	}

	input {
		font-size: 15px;
		width: 70%;
		border-width: 0px 0px 0px 1px;
		border-radius: 0px 0px 0px 0px;
		border-color: #d8d8d8;
		outline: none
	}

	.embed-url-submit {
		cursor: pointer;
		margin: 0 5px;
	}
`;

export const EmbedUrlGuidleines = styled.div`
	display: flex;
	flex-direction: column;
	gap: 5px;
	padding: 10px;

	.title {
 		font-size: 15px;
	}

	.sub-title {
 		font-size: 12px;
	}

	.instructions {
 		display: flex;
		flex-direction: column;
		gap: 5px;

 		p {
 			font-size: 15px;
			font-weight: 500;
		}

 		span {
 			font-size: 12px;
			background: #282828;
			color: #e2e2e2;
			padding: 5px 5px 5px 15px;
			border-radius: 5px;
			align-items: center;
			display: flex;
		}
	}
`

const EditCommunityContainer = styled(AddCommunityContainer)``
const EditCommunityNew = ({ 
    fieldErrors = {},
    community_description,
    community,
    images,
    videos,
    highlights,
    allHighlights,
    agent
}) => {
    const { communityData ,setCommunityData, loading, setLoading } = useContext(MainContext)
    const [_fieldErrors, _setFieldErrors] = useState(fieldErrors)
    const [chd, setCHD] = useState( community_description && community_description.split('\n') || [''])
    const [selectedHighlights, setSelectedHighlights] = useState(highlights || [])
    const [showHighlightsModal, setShowHighlightsModal] = useState(false)
    const [keyword, setKeyword] = useState('')
    const [toggleVideoUpload, setToggleVideoUpload] = useState(true)
    const [highlightsPhotos, setHighlightsPhotos] = useState([])
    const [customHighlights, setCustomHighlights] = useState([])
    const [embedUrlValue, setEmbedUrlValue] = useState('')
    const [embedURLs, setEmbedURLs] = useState([])
    const [showVideoError, setShowVideoError] = useState(true)

    const removeCustomHighlightPhoto = (h) => {
        if(communityData[h]) {
            delete communityData[h]
            setCommunityData(communityData)
        }
        setHighlightsPhotos(highlightsPhotos.filter(hp => hp !== h))
    }

    const removeCustomHighlight = (c) => {
     setCustomHighlights(customHighlights.filter(cp => cp !== c))
    }

    const handleCustomHighlightChange = (e, index) => {
        const copych = customHighlights
        copych[index] =  {
            value: e.target.value,
            key: index
        }
        setCustomHighlights([...copych])
    }
 
    const handleChange = (e) => {
        const { name, value } = e.target
        setCommunityData({
            ...communityData,
            [name]: (name == 'photos' || name == 'videos') ?  communityData[name].concat(Array.from(value)) : value
        })
        _setFieldErrors({
            ..._fieldErrors,
            [name]: ''
        })
    }

    const handleSetEmbedUrlValue = (e) => {
        setEmbedUrlValue(e.target.value)
    }

    const isValidString = (url) => {
        const pattern = /youtube|vimeo/;
        return pattern.test(url);
    }
      

    const handleAddEmbedUrl = (e) => {
        e.preventDefault();

        if (embedUrlValue.trim() !== '' && isValidString(embedUrlValue)) {
            setCommunityData({
                ...communityData,
                embed_urls: [...embedURLs, embedUrlValue]
            })
            setEmbedURLs((prevEmbedURLs) => [...prevEmbedURLs, embedUrlValue]);
            setEmbedUrlValue('');
        } else {
            setShowVideoError(true)
            setTimeout(() => {
                console.log('closed')
              setShowVideoError(false)
            }, 3000);
        }
    };

    const handleDeleteEmbedURL = (index) => {
        setCommunityData({
            ...communityData,
            embed_urls: embedURLs.filter((_, i) => i !== index)
        })
        setEmbedURLs((prevEmbedURLs) => prevEmbedURLs.filter((_, i) => i !== index));
    };

    const handleChangeWithIndex = (e, index) => {
        const { name, value } = e.target
        if(name === 'community_description') {
            const copyCHD = chd
            copyCHD[index] = value
            setCHD([...copyCHD])
        }
    }

    useEffect(() => {
        if(community && community.address && community.builder) {
            setCommunityData({
                ...community,
                address_id: community.address.id,
                city: community.address.city,
                state: community.address.state,
                zip: community.address.zip,
                street: community.address.street,
                builder_id: community.builder.id,
                builder_name: community.builder.name,
                builder_description: community.builder.description,
                builder_content: community.builder.builder_content,
                builder_highlight_details: community.builder.builder_highlight_details,
                photos: images,
                videos: videos,
                deleted_images: [],
                deleted_videos: [],
            })
            if(community.additional_highlights) {
                setCustomHighlights(JSON.parse(community.additional_highlights))
            } 
        }
    },[community])


    useEffect(() => {
        setCommunityData({
          ...communityData,
          ['additional_highlights']: JSON.stringify(customHighlights),
        });
      }, [customHighlights]);

    useEffect(() => {
        if(community_description) {
            setCHD(community_description.split('\n').filter(s => s != ''))
        }
    }, [community_description])

    useEffect(() => {
        setCommunityData({
            ...communityData,
            ['community_highlights_description']: chd.join('\n')
        })
    },[chd])

    useEffect(() => {
        setCommunityData({
            ...communityData,
            ['highlights']: selectedHighlights
        })
    },[ selectedHighlights])

    useEffect(() => {
        if(highlights) {
            setSelectedHighlights(highlights.map(h => { return {...h, value: h.id}}))
        }
    }, [highlights])

    useEffect(() => {
        if(images) {
            setCommunityData({
                ...communityData,
                ['photos']: images,
                ['videos']: videos
            })
            

            setHighlightsPhotos(images.filter(img => img.location && img.location.startsWith('highlights_')).map(img => img.location))
        }
    }, [images])

    useEffect(() => {
        _setFieldErrors(fieldErrors)
    }, [fieldErrors])
    const [officers, setOfficers] = useState([])
    useEffect(() => {
      async function fetchOfficers() {
        const result = await getOfficers();
        setOfficers(result.results)
      }
  
      fetchOfficers()
    }, [])
    return (
        communityData && <EditCommunityContainer>
            <HeroAndCommunityNameWrapper>
                <HeroWrapper>
                    <HeroLeftCol>
                        <UploadPhoto 
                            name="hero_0" 
                            communityFiles={communityData['hero_0'] && Array.from(communityData['hero_0'] ) || images.filter(img => img.location == 'hero_0')}  handleChange={handleChange}/> 
                    </HeroLeftCol>
                    <HeroRightCol>
                        <HeroRightColImages>
                            <HeroRightColImage>
                                <UploadPhoto 
                                    name="hero_1"
                                    communityFiles={communityData['hero_1'] && Array.from(communityData['hero_1'] ) || images.filter(img => img.location == 'hero_1')} 
                                    handleChange={handleChange} />
                            </HeroRightColImage>
                            <HeroRightColImage>
                                <UploadPhoto 
                                    name="hero_2"
                                    communityFiles={communityData['hero_2'] && Array.from(communityData['hero_2'] ) || images.filter(img => img.location == 'hero_2')} 
                                    handleChange={handleChange} />
                            </HeroRightColImage>
                            <HeroRightColImage>
                                <UploadPhoto 
                                    name="hero_3"
                                    communityFiles={communityData['hero_3'] && Array.from(communityData['hero_3'] ) || images.filter(img => img.location == 'hero_3')} 
                                    handleChange={handleChange} />
                            </HeroRightColImage>
                            <HeroRightColImage>
                                <UploadPhoto 
                                    name="hero_4"
                                    communityFiles={communityData['hero_4'] && Array.from(communityData['hero_4'] ) || images.filter(img => img.location == 'hero_4')} 
                                    handleChange={handleChange} />
                            </HeroRightColImage>

                        </HeroRightColImages>
                    </HeroRightCol>
                </HeroWrapper>
                <CommunityNameWrapper>
                    <CommunityNameDetailsWrapper>
                        <CommunityNameDetails>
                            <input type="text" name="name"  value={communityData.name} onChange={handleChange} class="community-name" placeholder="Community Name" />
                            {_fieldErrors.name && <FieldErrorMessage>{_fieldErrors.name}</FieldErrorMessage>}
                            <input type="text" name="street"  value={communityData.street} onChange={handleChange} class="community-address" placeholder="Street" />
                            
                            <div style={{display: 'flex', gap: 16}}>
                              <input type="text" name="city"  value={communityData.city} onChange={handleChange} class="community-address" placeholder="City" />
                              {_fieldErrors.city && <FieldErrorMessage>{_fieldErrors.city}</FieldErrorMessage>}
                              <select class="community-address" name="state" value={communityData.state} onChange={handleChange} placeholder="State">
                                  {US_STATES.map(s => <option value={s.value}>{s.name}</option>)}
                              </select>
                              {_fieldErrors.state && <FieldErrorMessage>{_fieldErrors.state}</FieldErrorMessage>}
                              <input type="text" name="zip"  value={communityData.zip} onChange={handleChange} class="community-address" placeholder="Zip" />
                            </div>
                            <div style={{display: 'flex', gap: 16, width: '100%'}}>
                              <div style={{width: '100%'}}>
                                <input type="text" value={communityData.url} name="url" onChange={handleChange} class="community-address" placeholder="NHS URL" />
                                {communityData.url && !isValidUrl(communityData.url) && <FieldErrorMessage>Not a valid URL</FieldErrorMessage>}
                              </div>
                              <HomesButton style={{height: 66.39}} onClick={() => window.open(communityData.url, '_blank')} disabled={!isValidUrl(communityData.url)}>
                                PREVIEW
                              </HomesButton>
                            </div>

                            <div style={{display: 'flex', gap: 16, width: '100%'}}>
                              <div style={{width: '100%'}}>
                                <input type="text" value={communityData.fallback_nhs_url} name="fallback_nhs_url" onChange={handleChange} class="community-address" placeholder="FALLBACK NHS URL" />
                                {communityData.fallback_nhs_url && !isValidUrl(communityData.fallback_nhs_url) && <FieldErrorMessage>Not a valid URL</FieldErrorMessage>}
                              </div>
                              <HomesButton style={{height: 66.39}} onClick={() => window.open(communityData.fallback_nhs_url, '_blank')} disabled={!isValidUrl(communityData.fallback_nhs_url)}>
                                PREVIEW
                              </HomesButton>
                            </div>
                            <AgentDetailsInputGroup>
                                <label style={{minWidth: 200}}>Loan Officer</label>
                                <Select
                                name="loan_officer"
                                className='loan-officer-container'
                                classNamePrefix='loan-officer-select'
                                options={officers.map(o => { return {value: o.id, label: o.first_name + ' ' + o.last_name} }).concat({value: null, label: 'Clear'})}
                                onChange={(option) =>  {
                                    if(option.value == null) {
                                        setCommunityData({
                                            ...communityData,
                                            ["loan_officer"]: null,
                                        })
                                    } else {
                                        setCommunityData({
                                            ...communityData,
                                            ["loan_officer"]: option,
                                        })
                                    }
                                }
                                }
                                value={communityData.loan_officer}
                                />
                            </AgentDetailsInputGroup>
                            <CommunityByWrapper>
                                <label>Community by</label>
                                <input type="text" name="builder_name" value={communityData.builder_name} onChange={handleChange} placeholder="Builder Name" />
                                {_fieldErrors.builder_name && <FieldErrorMessage>{_fieldErrors.builder_name}</FieldErrorMessage>}
                            </CommunityByWrapper>
                            <textarea name="description" onChange={handleChange} value={communityData.description} placeholder="Community Description"></textarea>
                            {_fieldErrors.description && <FieldErrorMessage>{_fieldErrors.description}</FieldErrorMessage>}
                          
                        </CommunityNameDetails>
                    </CommunityNameDetailsWrapper>
                </CommunityNameWrapper> 
            </HeroAndCommunityNameWrapper>
            <QuickFactsWrapper>
                <QuickFactsContentWrapper>
                    <QuickFactsLeftCol>
                        <UploadPhoto 
                            name="section_0" 
                            communityFiles={communityData['section_0'] && Array.from(communityData['section_0'] ) || images.filter(img => img.location == 'section_0')} 
                            handleChange={handleChange} />
                    </QuickFactsLeftCol>
                    <QuickFactsRightCol>
                        <QuickFactsRightColDetails>
                            <QuickFactsTextDetails>
                                <FactsCard>
                                    <FactsCardIconWrapper>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="67" height="66" viewBox="0 0 67 66" fill="none">
                                    <path d="M33.7506 0.5H33.75C27.3221 0.5 21.0386 2.40609 15.694 5.97724C10.3494 9.54838 6.18378 14.6242 3.72393 20.5628C1.26408 26.5014 0.620473 33.036 1.87449 39.3404C3.12851 45.6448 6.22384 51.4358 10.769 55.981C15.3142 60.5262 21.1052 63.6215 27.4096 64.8755C33.714 66.1295 40.2486 65.4859 46.1872 63.0261C52.1258 60.5662 57.2016 56.4006 60.7728 51.056C64.3439 45.7114 66.25 39.4279 66.25 33V32.9994C66.2399 24.3831 62.8126 16.1227 56.72 10.03C50.6273 3.9374 42.3669 0.510119 33.7506 0.5ZM33.7495 60.7353C28.2641 60.7352 22.902 59.1085 18.3411 56.061C13.7801 53.0135 10.2252 48.6818 8.12594 43.6138C6.02672 38.5459 5.47747 32.9692 6.54765 27.5891C7.61782 22.209 10.2593 17.267 14.1382 13.3882C18.017 9.50933 22.959 6.8678 28.3391 5.79763C33.7192 4.72746 39.2959 5.27671 44.3638 7.37593C49.4318 9.47515 53.7635 13.03 56.8111 17.5911C59.8585 22.152 61.4852 27.5141 61.4853 32.9994C61.4771 40.3529 58.5524 47.4029 53.3526 52.6026C48.1529 57.8023 41.103 60.7271 33.7495 60.7353ZM43.636 45.3958C45.2595 43.7724 46.1716 41.5704 46.1716 39.2745C46.1716 36.9786 45.2595 34.7766 43.636 33.1532C42.0126 31.5297 39.8107 30.6176 37.5147 30.6176H29.9853C28.953 30.6176 27.9631 30.2076 27.2331 29.4777C26.5032 28.7477 26.0931 27.7577 26.0931 26.7255C26.0931 25.6932 26.5032 24.7032 27.2331 23.9733C27.9631 23.2434 28.953 22.8333 29.9853 22.8333H41.2794C41.9113 22.8333 42.5172 22.5823 42.964 22.1356C43.4108 21.6888 43.6618 21.0828 43.6618 20.451C43.6618 19.8191 43.4108 19.2132 42.964 18.7664C42.5172 18.3196 41.9113 18.0686 41.2794 18.0686H36.1324V15.4314C36.1324 14.7995 35.8814 14.1936 35.4346 13.7468C34.9878 13.3 34.3818 13.049 33.75 13.049C33.1182 13.049 32.5122 13.3 32.0654 13.7468C31.6187 14.1936 31.3677 14.7995 31.3677 15.4314V18.0686H29.9853C27.6894 18.0686 25.4875 18.9807 23.864 20.6042C22.2405 22.2276 21.3284 24.4295 21.3284 26.7255C21.3284 29.0214 22.2405 31.2233 23.864 32.8468C25.4875 34.4703 27.6894 35.3823 29.9853 35.3823H37.5147C38.547 35.3823 39.537 35.7924 40.2669 36.5223C40.9968 37.2523 41.4069 38.2422 41.4069 39.2745C41.4069 40.3068 40.9968 41.2967 40.2669 42.0267C39.537 42.7566 38.547 43.1667 37.5147 43.1667H26.2206C25.5888 43.1667 24.9828 43.4177 24.536 43.8644C24.0892 44.3112 23.8382 44.9172 23.8382 45.549C23.8382 46.1808 24.0892 46.7868 24.536 47.2336C24.9828 47.6804 25.5888 47.9314 26.2206 47.9314H31.3677V50.5686C31.3677 51.2005 31.6187 51.8064 32.0654 52.2532C32.5122 52.7 33.1182 52.951 33.75 52.951C34.3818 52.951 34.9878 52.7 35.4346 52.2532C35.8814 51.8064 36.1324 51.2005 36.1324 50.5686V47.9314H37.5147C39.8107 47.9314 42.0126 47.0193 43.636 45.3958Z" fill="#5284E0" stroke="#5284E0"/>
                                    </svg>
                                    </FactsCardIconWrapper>
                                    <FactsCardTextContentWrapper>
                                        <label>Min:</label>
                                        <input type="number" name="price_min" value={communityData.price_min} onChange={handleChange} placeholder="Min Price" min={1} />
                                        {_fieldErrors.price_min && <FieldErrorMessage>{_fieldErrors.price_min[0]}</FieldErrorMessage>}
                            
                                    </FactsCardTextContentWrapper>
                                    <FactsCardTextContentWrapper>
                                        <label>Max:</label>
                                        <input type="number" name="price_max" value={communityData.price_max} onChange={handleChange} placeholder="Max Price" min={1} />
                                        {_fieldErrors.price_max && <FieldErrorMessage>{_fieldErrors.price_max[0]}</FieldErrorMessage>}
                            
                                    </FactsCardTextContentWrapper>
                                </FactsCard>
                                <FactsCard>
                                    <FactsCardIconWrapper>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="65" height="64" viewBox="0 0 65 64" fill="none">
                                    <path d="M37.05 25.7134V29.9277H28.45V25.7134V24.5216L27.5996 25.3567L21.1996 31.6424L20.8364 31.9992L21.1996 32.3559L27.5996 38.6416L28.45 39.4768V38.2849V34.0706H37.05V38.2849V39.4768L37.9004 38.6416L44.3004 32.3559L44.6636 31.9992L44.3004 31.6424L37.9004 25.3567L37.05 24.5216V25.7134ZM16.75 18.9277H16.25V19.4277V44.5706V45.0706H16.75H19.95H20.45V44.5706V19.4277V18.9277H19.95H16.75ZM45.55 18.9277H45.05V19.4277V44.5706V45.0706H45.55H48.75H49.25V44.5706V19.4277V18.9277H48.75H45.55Z" fill="#5284E0" stroke="#5284E0"/>
                                    <circle cx="32.75" cy="32" r="29" stroke="#5284E0" strokeWidth="6"/>
                                    </svg>
                                    </FactsCardIconWrapper>
                                    <FactsCardTextContentWrapper>
                                        <label>Min:</label>
                                        <input type="number" name="area_min" value={communityData.area_min} onChange={handleChange} placeholder="Min Area" min={1} />
                                        {_fieldErrors.area_min && <FieldErrorMessage>{_fieldErrors.area_min[0]}</FieldErrorMessage>}
                            
                                    </FactsCardTextContentWrapper>
                                    <FactsCardTextContentWrapper>
                                        <label>Max:</label>
                                        <input type="number" name="area_max" value={communityData.area_max} onChange={handleChange} placeholder="Max Area" min={1} />
                                        {_fieldErrors.area_max && <FieldErrorMessage>{_fieldErrors.area_max[0]}</FieldErrorMessage>}
                            
                                    </FactsCardTextContentWrapper>
                                </FactsCard>
                                <FactsCard160>
                                    <FactsCardIconWrapper>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="70" height="66" viewBox="0 0 70 66" fill="none">
                                    <path d="M37.5823 1.91316L37.5822 1.91311C36.6771 1.0083 35.4497 0.5 34.1699 0.5C32.8901 0.5 31.6627 1.00829 30.7576 1.91311L30.7576 1.91313L1.99962 30.6665L1.99959 30.6665C1.75204 30.9141 1.55566 31.208 1.42169 31.5314C1.28771 31.8549 1.21875 32.2015 1.21875 32.5516C1.21875 32.9017 1.28771 33.2484 1.42169 33.5719C1.55566 33.8953 1.75204 34.1892 1.99959 34.4367C2.49956 34.9367 3.17765 35.2176 3.88471 35.2176C4.23481 35.2176 4.58148 35.1486 4.90493 35.0147C5.22838 34.8807 5.52227 34.6843 5.76983 34.4367L5.7701 34.4365L7.71117 32.4924V54.1837C7.71117 56.0375 8.44758 57.8153 9.7584 59.1261C11.0692 60.437 12.8471 61.1734 14.7009 61.1734H32.0067C32.713 61.1734 33.3904 60.8928 33.8899 60.3933C34.3893 59.8939 34.6699 59.2165 34.6699 58.5101C34.6699 57.8038 34.3893 57.1264 33.8899 56.627C33.3904 56.1275 32.713 55.8469 32.0067 55.8469H14.7009C14.2597 55.8469 13.8367 55.6717 13.5248 55.3598C13.2129 55.0479 13.0376 54.6248 13.0376 54.1837V27.1647L34.1699 6.03262L62.57 34.4367L62.57 34.4367C63.07 34.9367 63.7481 35.2176 64.4551 35.2176C65.1622 35.2176 65.8403 34.9367 66.3402 34.4367C66.8402 33.9368 67.1211 33.2587 67.1211 32.5516C67.1211 31.8446 66.8402 31.1665 66.3402 30.6665L66.3402 30.6665L56.3022 20.6329V6.59313C56.3022 5.88681 56.0216 5.20941 55.5222 4.70996C55.0227 4.21051 54.3453 3.92993 53.639 3.92993H49.3125C48.6062 3.92993 47.9288 4.21051 47.4293 4.70996L47.7829 5.06352L47.4293 4.70996C46.9299 5.20941 46.6493 5.88681 46.6493 6.59313V10.9801L37.5823 1.91316ZM51.4758 48.1943H51.9758V47.6943V43.3679C51.9758 42.9268 52.151 42.5038 52.463 42.1918C52.7749 41.8799 53.1979 41.7047 53.639 41.7047C54.0802 41.7047 54.5032 41.8799 54.8151 42.1918C55.127 42.5038 55.3023 42.9268 55.3023 43.3679V47.6943V48.1943H55.8023H60.1287C60.5698 48.1943 60.9929 48.3696 61.3048 48.6815C61.6167 48.9934 61.792 49.4164 61.792 49.8575C61.792 50.2986 61.6167 50.7217 61.3048 51.0336C60.9929 51.3455 60.5698 51.5207 60.1287 51.5207H55.8023H55.3023V52.0207V56.3472C55.3023 56.7883 55.127 57.2113 54.8151 57.5232C54.5032 57.8351 54.0802 58.0104 53.639 58.0104C53.1979 58.0104 52.7749 57.8351 52.463 57.5232C52.151 57.2113 51.9758 56.7883 51.9758 56.3472V52.0207V51.5207H51.4758H47.1494C46.7082 51.5207 46.2852 51.3455 45.9733 51.0336C45.6614 50.7217 45.4861 50.2986 45.4861 49.8575C45.4861 49.4164 45.6614 48.9934 45.9733 48.6815C46.2852 48.3696 46.7082 48.1943 47.1494 48.1943H51.4758ZM64.7 60.9184C67.6336 57.9849 69.2816 54.0062 69.2816 49.8575C69.2816 45.7089 67.6336 41.7302 64.7 38.7966C61.7665 35.8631 57.7877 34.2151 53.639 34.2151C49.4904 34.2151 45.5116 35.8631 42.5781 38.7966C39.6445 41.7302 37.9964 45.7089 37.9964 49.8575C37.9964 54.0062 39.6445 57.9849 42.5781 60.9184C45.5116 63.852 49.4904 65.5 53.639 65.5C57.7877 65.5 61.7665 63.852 64.7 60.9184Z" fill="#5284E0" stroke="#5284E0"/>
                                    </svg>
                                    </FactsCardIconWrapper>
                                    <input  type="number" name="homes" value={communityData.homes} onChange={handleChange} placeholder="Quantity" />
                                    {_fieldErrors.homes && <FieldErrorMessage>{_fieldErrors.homes[0]}</FieldErrorMessage>}
                                    <p>New Homes</p>
                                    
                                </FactsCard160>
                                <FactsCard160>
                                    <FactsCardIconWrapper>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="70" height="66" viewBox="0 0 70 66" fill="none">
                                    <path d="M30.7575 1.91311L30.7574 1.91314L1.99962 30.6666L1.99959 30.6667C1.75203 30.9142 1.55566 31.2081 1.42168 31.5315C1.28771 31.855 1.21875 32.2017 1.21875 32.5518C1.21875 32.9019 1.28771 33.2485 1.42168 33.572C1.55566 33.8954 1.75203 34.1893 1.99959 34.4369C2.24715 34.6844 2.54104 34.8808 2.86448 35.0148C3.18794 35.1488 3.53461 35.2177 3.8847 35.2177C4.23479 35.2177 4.58146 35.1488 4.90491 35.0148C5.22836 34.8808 5.52225 34.6844 5.76981 34.4369L5.77008 34.4366L7.71113 32.4925V54.1839C7.71113 56.0377 8.44754 57.8155 9.75836 59.1264C11.0692 60.4372 12.847 61.1736 14.7008 61.1736H32.0065C32.7129 61.1736 33.3903 60.893 33.8897 60.3935C34.3892 59.8941 34.6697 59.2167 34.6697 58.5104C34.6697 57.804 34.3892 57.1266 33.8897 56.6272C33.3903 56.1277 32.7129 55.8471 32.0065 55.8471H14.7008C14.2597 55.8471 13.8366 55.6719 13.5247 55.36C13.2128 55.0481 13.0376 54.625 13.0376 54.1839V27.1648L34.1697 6.03264L62.5696 34.4368L62.5697 34.4369C62.8172 34.6844 63.1111 34.8808 63.4346 35.0148C63.758 35.1488 64.1047 35.2177 64.4548 35.2177C64.8049 35.2177 65.1516 35.1488 65.475 35.0148C65.7984 34.8808 66.0923 34.6844 66.3399 34.4369C66.5874 34.1893 66.7838 33.8954 66.9178 33.572C67.0518 33.2485 67.1207 32.9019 67.1207 32.5518C67.1207 32.2017 67.0518 31.855 66.9178 31.5315C66.7838 31.2081 66.5874 30.9142 66.3399 30.6667L66.3398 30.6666L56.3019 20.6329V6.59316C56.3019 5.88683 56.0213 5.20943 55.5219 4.70998C55.0224 4.21053 54.345 3.92994 53.6387 3.92994H49.3123C48.6059 3.92994 47.9285 4.21053 47.4291 4.70998C46.9296 5.20943 46.649 5.88683 46.649 6.59316V10.9801L37.5821 1.91317L37.582 1.91311C36.6769 1.0083 35.4495 0.5 34.1697 0.5C32.8899 0.5 31.6625 1.0083 30.7575 1.91311ZM51.1217 46.0733L48.3269 48.8725C48.0149 49.1849 47.5917 49.3605 47.1503 49.3608C46.7089 49.3612 46.2854 49.1861 45.973 48.8742C45.6607 48.5623 45.485 48.139 45.4847 47.6976C45.4844 47.2562 45.6594 46.8327 45.9713 46.5203L52.4608 40.0309L52.4612 40.0305C52.6157 39.8756 52.7992 39.7527 53.0013 39.6689L52.8097 39.207L53.0013 39.6689C53.2034 39.585 53.42 39.5419 53.6388 39.5419C53.8575 39.5419 54.0742 39.585 54.2762 39.6689L54.4678 39.207L54.2762 39.6689C54.4783 39.7527 54.6618 39.8756 54.8163 40.0305L55.6703 40.8867V40.8802L61.3064 46.5163C61.6188 46.8287 61.7944 47.2524 61.7944 47.6943C61.7944 48.1361 61.6188 48.5598 61.3064 48.8723C60.994 49.1847 60.5703 49.3602 60.1284 49.3602C59.6867 49.3602 59.2631 49.1848 58.9507 48.8725C58.9507 48.8725 58.9507 48.8725 58.9506 48.8725C58.9506 48.8724 58.9505 48.8723 58.9504 48.8723L56.1558 46.0733L55.302 45.2182V46.4266V58.5103C55.302 58.9515 55.1267 59.3745 54.8148 59.6864C54.5029 59.9983 54.0799 60.1736 53.6388 60.1736C53.1976 60.1736 52.7746 59.9983 52.4627 59.6864C52.1508 59.3745 51.9755 58.9515 51.9755 58.5103V46.4266V45.2182L51.1217 46.0733ZM53.6388 65.5C57.7874 65.5 61.7662 63.852 64.6997 60.9184C67.6332 57.9849 69.2813 54.0061 69.2813 49.8575C69.2813 45.7088 67.6332 41.7301 64.6997 38.7965C61.7662 35.863 57.7874 34.215 53.6388 34.215C49.4901 34.215 45.5114 35.863 42.5778 38.7965C39.6443 41.7301 37.9962 45.7088 37.9962 49.8575C37.9962 54.0061 39.6443 57.9849 42.5778 60.9184C45.5114 63.852 49.4901 65.5 53.6388 65.5Z" fill="#5284E0" stroke="#5284E0"/>
                                    </svg>
                                    </FactsCardIconWrapper>
                                    <input type="number" name="quick_move_ins" value={communityData.quick_move_ins} onChange={handleChange} placeholder="Quantity" />
                                    {_fieldErrors.quick_move_ins && <FieldErrorMessage>{_fieldErrors.quick_move_ins[0]}</FieldErrorMessage>}
                                    <p>Quick Move-Ins</p>
                                </FactsCard160>
                            </QuickFactsTextDetails>
                        </QuickFactsRightColDetails>
                    </QuickFactsRightCol>
                </QuickFactsContentWrapper>
            </QuickFactsWrapper>
            <HighlightsWrapper> 
                <SectionHeader title="Highlights" />
                <div className="section__content-wrapper">
                    <div className="section__description">
                        <textarea
                            placeholder="Community Highlights Description"
                            name="highlights_description"
                            value={communityData.highlights_description}
                            onChange={handleChange}></textarea>
                    </div>
                </div>

                <div className="section__highlight-card-wrapper">
                    {selectedHighlights.map(highlight => (
                        <div className="section__highlight-card">
                            <div className="section__highlight-menu">
                                <EditIcon onClick={() => setShowHighlightsModal(!showHighlightsModal)} />
                                <CloseIcon 
                                    onClick={() => 
                                        setSelectedHighlights([...selectedHighlights.filter(h => h.value !== highlight.value)])} />
                            </div>
                            <HighlightIcon variant={highlight.name} />
                            <h5>{highlight.name}</h5>
                        </div> 
                    ))}
                    <div className="section__highlight-card" onClick={() => setShowHighlightsModal(!showHighlightsModal)}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="104" height="120" viewBox="0 0 76 75" fill="none">
                        <path d="M61.1975 42.8275C60.2506 42.8275 59.3424 43.2037 58.6728 43.8733C58.0033 44.5429 57.6271 45.451 57.6271 46.3979V47.7547L52.3428 42.4705C50.477 40.6194 47.9552 39.5806 45.3269 39.5806C42.6986 39.5806 40.1768 40.6194 38.311 42.4705L35.8117 44.9698L26.957 36.1151C25.0651 34.3142 22.5531 33.3097 19.9411 33.3097C17.329 33.3097 14.8171 34.3142 12.9251 36.1151L7.64089 41.3993V21.4049C7.64089 20.4579 8.01706 19.5498 8.68664 18.8802C9.35623 18.2106 10.2644 17.8344 11.2113 17.8344H36.2044C37.1514 17.8344 38.0595 17.4582 38.7291 16.7886C39.3987 16.1191 39.7749 15.2109 39.7749 14.264C39.7749 13.317 39.3987 12.4089 38.7291 11.7393C38.0595 11.0697 37.1514 10.6935 36.2044 10.6935H11.2113C8.37051 10.6935 5.64604 11.822 3.63728 13.8308C1.62851 15.8396 0.5 18.564 0.5 21.4049V64.2502C0.5 67.091 1.62851 69.8155 3.63728 71.8242C5.64604 73.833 8.37051 74.9615 11.2113 74.9615H54.0566C56.8975 74.9615 59.6219 73.833 61.6307 71.8242C63.6395 69.8155 64.768 67.091 64.768 64.2502V46.3979C64.768 45.451 64.3918 44.5429 63.7222 43.8733C63.0526 43.2037 62.1445 42.8275 61.1975 42.8275ZM11.2113 67.8206C10.2644 67.8206 9.35623 67.4444 8.68664 66.7749C8.01706 66.1053 7.64089 65.1971 7.64089 64.2502V51.5037L17.9952 41.1494C18.5197 40.6495 19.2165 40.3707 19.9411 40.3707C20.6656 40.3707 21.3624 40.6495 21.887 41.1494L33.2053 52.4677L48.5582 67.8206H11.2113ZM57.6271 64.2502C57.6219 64.9336 57.3966 65.5973 56.9844 66.1425L40.8817 49.9684L43.381 47.4691C43.637 47.2078 43.9425 47.0003 44.2797 46.8586C44.6169 46.7169 44.979 46.6439 45.3448 46.6439C45.7105 46.6439 46.0726 46.7169 46.4098 46.8586C46.747 47.0003 47.0525 47.2078 47.3085 47.4691L57.6271 57.8591V64.2502ZM74.4439 11.729L63.7325 1.01762C63.393 0.692569 62.9926 0.437764 62.5543 0.267831C61.685 -0.0892772 60.71 -0.0892772 59.8408 0.267831C59.4025 0.437764 59.0021 0.692569 58.6625 1.01762L47.9512 11.729C47.2789 12.4013 46.9011 13.3132 46.9011 14.264C46.9011 15.2148 47.2789 16.1267 47.9512 16.799C48.6235 17.4713 49.5354 17.849 50.4862 17.849C51.437 17.849 52.3489 17.4713 53.0212 16.799L57.6271 12.1574V32.1162C57.6271 33.0631 58.0033 33.9713 58.6728 34.6409C59.3424 35.3105 60.2506 35.6866 61.1975 35.6866C62.1445 35.6866 63.0526 35.3105 63.7222 34.6409C64.3918 33.9713 64.768 33.0631 64.768 32.1162V12.1574L69.3738 16.799C69.7058 17.1336 70.1007 17.3993 70.5357 17.5805C70.9708 17.7618 71.4375 17.8551 71.9089 17.8551C72.3802 17.8551 72.8469 17.7618 73.282 17.5805C73.7171 17.3993 74.1119 17.1336 74.4439 16.799C74.7785 16.4671 75.0441 16.0722 75.2254 15.6371C75.4067 15.202 75.5 14.7353 75.5 14.264C75.5 13.7926 75.4067 13.3259 75.2254 12.8909C75.0441 12.4558 74.7785 12.0609 74.4439 11.729Z" fill="#BCBCBC"/>
                        </svg>
                        <h5>ADD HIGHLIGHT</h5>
                    </div>
                </div>
                {chd.map((c, index) => 
                <SectionDetails className="section__details">
                    {index > 0 && <CloseIcon onClick={() => {
                        const copyCHD = chd
                        copyCHD.pop()
                        setCHD([...copyCHD])
                        return
                    }} /> }
                    <SectionDetailsLeftCol className="section__details-left-col">
                        <SectionDetailsText value={c} handleChangeWithIndex={handleChangeWithIndex} index={index}/>
                    </SectionDetailsLeftCol>
                    <SectionDetailsRightCol className="section__details-right-col">
                        <UploadPhoto 
                            name={`section_${index + 1}`}
                            communityFiles={communityData[`section_${index + 1}`] && Array.from(communityData[`section_${index + 1}`] ) || images.filter(img => img.location == `section_${index + 1}`)} 
                            handleChange={handleChange} />
                    </SectionDetailsRightCol>
                </SectionDetails>
                )}


                <HomesButton onClick={() =>  setCHD([...chd, ''])}>
                    ADD MORE COMMUNITY HIGHLIGHTS DETAILS
                </HomesButton>

                <CustomHighlightsContent
                    headerTitle={"Upload Highlight Photos (max of 4 images)"}
                    tooltipText={"Upload Photo"}
                    onAddClick={() => {
                        if(highlightsPhotos.length < 4) {
                        setHighlightsPhotos([...highlightsPhotos, 'highlights_'+(highlightsPhotos.length + 1)])
                        }
                        }}>
                        {highlightsPhotos.length > 0 && <div className='__images'>
                            {highlightsPhotos.map((hp, index) => (
                            <CustomHighlightPhoto
                                key={hp}
                                name={hp}
                                communityFiles={communityData[hp] && Array.from(communityData[hp] ) || images.filter(img => img.location == hp)} 
                                handleChange={handleChange}
                                remove={() => {
                                    const copyPhotos = Array.from(communityData.photos)
                                    if(copyPhotos.find(f => f.location === hp)) {
                                        setCommunityData({
                                            ...communityData,
                                            ['photos']: [...copyPhotos.filter(c => c.location != hp)],
                                            ['deleted_images']: [...communityData.deleted_images, copyPhotos.find(f => f.location === hp)]
                                        })
                                    }
                                    
                                    removeCustomHighlightPhoto(hp)
                                    return
                                }}/>
                            ))}
                        </div>}
                    </CustomHighlightsContent>
                    <CustomHighlightsContent
                    headerTitle="Add Custom Highlights"
                    tooltipText="Add Row"
                    onAddClick={() => {
                        setCustomHighlights([...customHighlights, { key: customHighlights.length, value: ''}])
                        
                        }}>
                        
                        { customHighlights.length > 0 && <div className="__text-fields">
                            {customHighlights.map((ch, index) => (
                            <CustomHighlightTextFieldGroup 
                                key={index}
                                value={ch.value}
                                handleChange={(e) => handleCustomHighlightChange(e, index)}
                                remove={() => removeCustomHighlight(ch)}/>
                            ))}
                        </div> }
                    </CustomHighlightsContent>
                
            </HighlightsWrapper>

            {agent && (
              <SectionAgentWrapper>
                <SectionAgentContainer>
                  <SectionHeader
                    className="section-agent-header"
                    title={`Hi! I'm <span>${agent.first_name} ${agent.last_name}</span>, your local community specialist. How can I help?`}
                  />
                  <SectionAgentContentWrapper>
                    <SectionAgentLeftCol>
                    
                      <img src={`${AGENT_PROFILE_URL}${agent.photo}`} className="w-100 cover" />
                    </SectionAgentLeftCol>
                    <SectionAgentRightCol>
                      <p>
                        We respect your privacy! Your information WILL NOT BE SHARED, SOLD, or RENTED to anyone, for any
                        reason outside the course of normal real estate exchange. By submitting, you agree to our{' '}
                        <a href="#">Terms of Use</a> and <a href="#">Privacy Policy.</a>
                      </p>
                      <SectionAgentForm>
                        <SectionAgentFormField>
                          <input
                            type="text"
                            name="name"
                            required
                            disabled
                            placeholder="Name"
                          />
                        </SectionAgentFormField>
                        <SectionAgentFormField>
                          <input
                            type="email"
                            disabled
                            name="email"
                            required
                            placeholder="Email"
                          />
                        </SectionAgentFormField>
                        <SectionAgentFormField>
                          <input
                            type="text"
                            disabled
                            name="phone"
                            required
                            placeholder="Phone"
                          />
                        </SectionAgentFormField>
                        <SectionAgentFormFieldText>
                          <textarea
                            disabled
                            name="message"
                            placeholder="Message"
                            required
                            rows={7}
                          ></textarea>
                        
                          <button type="submit" disabled>
                            {'SEND MESSAGE'}
                          </button>
                        </SectionAgentFormFieldText>
                      </SectionAgentForm>
                    </SectionAgentRightCol>
                  </SectionAgentContentWrapper>
                  <SectionAgentDetailsContainer>
                    <SectionAgentDetailsWrapper>
                      <SectionAgentDetailsTextFieldColWrapper>
                        <h3 style={{display: 'inline-flex', position: 'relative'}}>
                          {agent.first_name} {agent.last_name || ''}
                          <Link to={`/admin/agent/edit/${agent.id}`} title="goto agent">
                          <IconWrapper style={{position: 'absolute', top: -20, right: -40}}>
                            <EditIcon/>
                          </IconWrapper> 
                          </Link>
                        </h3>
                        <p>{communityData.name} Community Specialist</p>
                      </SectionAgentDetailsTextFieldColWrapper>
                      <SectionAgentDetailsTextFieldWrapper>
                        <SectionAgentDetailsTextFieldWrapperText>
                          <label>License:</label>
                          <p>{(agent && agent.licenses && agent.licenses.map((l) => l.license).join(', ')) || 'N/A'}</p>
                        </SectionAgentDetailsTextFieldWrapperText>
                        <SectionAgentDetailsTextFieldWrapperText>
                          <label>Phone:</label>
                          <p>{agent.mobile_phone}</p>
                        </SectionAgentDetailsTextFieldWrapperText>
                        <SectionAgentDetailsTextFieldWrapperText>
                          <label>Email:</label>
                          <p>{agent.email}</p>
                        </SectionAgentDetailsTextFieldWrapperText>
                      </SectionAgentDetailsTextFieldWrapper>
                      <div className="spacer"></div>
                      <SectionAgentDetailsTextFieldWrapperText>
                        <p>{agent.description}</p>
                      </SectionAgentDetailsTextFieldWrapperText>
                    </SectionAgentDetailsWrapper>
                  </SectionAgentDetailsContainer>
                </SectionAgentContainer>
              </SectionAgentWrapper>
            )}
            <SectionGalleryWrapper> 
                <SectionGallery>
                    <SectionHeader title="Gallery" />
                </SectionGallery>
                <SectionGalleryUploadWrapper>
                    <SectionGalleryUploadImageWrapper>
                        <SectionGalleryUploadImage>
                            <UploadPhoto title="UPLOAD PHOTO" name="photos" handleChange={handleChange}/>
                        </SectionGalleryUploadImage>
                        <SectionGalleryUploadImage>
                            <div style={{ display: toggleVideoUpload ? 'flex' : 'none', flexDirection: 'column', height: '100%' }}>
                                <div style={{ fontSize: '12px', cursor: 'pointer', position: 'absolute', padding: '12px 2px', zIndex: '5' }} onClick={() => {
                                   setToggleVideoUpload(false);
                                }}>Embed Video URL</div>
                                <UploadPhoto title="UPLOAD VIDEO" name="videos" handleChange={handleChange} isEmbedURL={true}/>
                            </div>

                            <div style={{ display: !toggleVideoUpload ? 'flex' : 'none', flexDirection: 'column', gap: '8px' }}>
                                <div style={{ fontSize: '12px', cursor: 'pointer', padding: '9px 14px' }} onClick={() => {
                                   setToggleVideoUpload(true);
                                }}>Upload Video</div>
                                <EmbedUrlGuidleines>
                                    <h3 className="title">Embed URL Video Guidelines</h3>
                                    <p className="sub-title">You can upload videos by providing an embed URL. Currently, we accept and support embed URLs from YouTube and Vimeo.</p>
                                    <div className="instructions">
																			<p>Accepted URL Formats</p>
																			<span>YouTube: {`https://www.youtube.com/embed/{video_id}`}</span>
																			<span>Vimeo: {`https://player.vimeo.com/video/{video_id}?h={hash}`}</span>
																		</div>
                                    <p className="sub-title">Please ensure your video URLs match the formats above for a successful upload.</p>
                                </EmbedUrlGuidleines>
                                <EmbedUrlForm onSubmit={handleAddEmbedUrl}>
                                    <p>Embed URL</p>
                                    <input
                                        onChange={handleSetEmbedUrlValue}
                                        type="url"
                                        value={embedUrlValue}
                                        name="embed_url"
                                    />
                                    <div className="embed-url-submit" onClick={(e) => {
                                        e.preventDefault();
                                        handleAddEmbedUrl(e);
                                    }}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                                            <path d="M10 0.859497C4.48 0.859497 0 5.3395 0 10.8595C0 16.3795 4.48 20.8595 10 20.8595C15.52 20.8595 20 16.3795 20 10.8595C20 5.3395 15.52 0.859497 10 0.859497ZM14 11.8595H11V14.8595C11 15.4095 10.55 15.8595 10 15.8595C9.45 15.8595 9 15.4095 9 14.8595V11.8595H6C5.45 11.8595 5 11.4095 5 10.8595C5 10.3095 5.45 9.8595 6 9.8595H9V6.8595C9 6.3095 9.45 5.8595 10 5.8595C10.55 5.8595 11 6.3095 11 6.8595V9.8595H14C14.55 9.8595 15 10.3095 15 10.8595C15 11.4095 14.55 11.8595 14 11.8595Z" fill="#979797"/>
                                        </svg>
                                    </div>
                                </EmbedUrlForm>
                            </div>
                        </SectionGalleryUploadImage>
                    </SectionGalleryUploadImageWrapper>
                </SectionGalleryUploadWrapper>
                <SectionGalleryMediaWrapper>

                <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                    <div
                        style={{
                            display: showVideoError ? 'flex' : 'none',
                            flexDirection: 'row',
                            flexWrap: 'wrap',
                            padding: '10px',
                            borderRadius: '4px',
                            border: '1px solid gray',
                            justifyContent: 'space-between',
                            gap: '10px',
                            fontSize: '15px' 
                        }}
                    >
                        <span style={{ color: 'red' }}>Invalid video url</span>
                    </div>
                    
                    { embedURLs && embedURLs.map((url, index) => {
                        return (
                            <div
                                key={index}
                                style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    flexWrap: 'wrap',
                                    padding: '10px',
                                    borderRadius: '4px',
                                    border: '1px solid gray',
                                    justifyContent: 'space-between',
                                    gap: '10px'
                                }}
                            >
                                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '10px' }}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="27" height="35" viewBox="0 0 30 38" fill="none">
                                        <path d="M9.375 30H16.875C17.4062 30 17.8519 29.82 18.2119 29.46C18.5719 29.1 18.7512 28.655 18.75 28.125V26.25L22.5 28.2187V20.5312L18.75 22.5V20.625C18.75 20.0938 18.57 19.6488 18.21 19.29C17.85 18.9312 17.405 18.7512 16.875 18.75H9.375C8.84375 18.75 8.39875 18.93 8.04 19.29C7.68125 19.65 7.50125 20.095 7.5 20.625V28.125C7.5 28.6562 7.68 29.1019 8.04 29.4619C8.4 29.8219 8.845 30.0012 9.375 30ZM3.75 37.5C2.71875 37.5 1.83625 37.1331 1.1025 36.3994C0.36875 35.6656 0.00125 34.7825 0 33.75V3.75C0 2.71875 0.3675 1.83625 1.1025 1.1025C1.8375 0.36875 2.72 0.00125 3.75 0H18.75L30 11.25V33.75C30 34.7812 29.6331 35.6644 28.8994 36.3994C28.1656 37.1344 27.2825 37.5013 26.25 37.5H3.75ZM16.875 13.125H26.25L16.875 3.75V13.125Z" fill="#636363"/>
                                    </svg>
                                    <p style={{ fontSize: '15px' }}>{ url }</p>
                                </div>
                                <div style={{ cursor: 'pointer' }} onClick={() => handleDeleteEmbedURL(index)}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                                        <path d="M10 0.145264C8.02219 0.145264 6.08879 0.731753 4.4443 1.83057C2.79981 2.92938 1.51809 4.49117 0.761209 6.31843C0.00433284 8.14569 -0.1937 10.1564 0.192152 12.0962C0.578004 14.036 1.53041 15.8178 2.92894 17.2163C4.32746 18.6149 6.10929 19.5673 8.0491 19.9531C9.98891 20.339 11.9996 20.1409 13.8268 19.3841C15.6541 18.6272 17.2159 17.3455 18.3147 15.701C19.4135 14.0565 20 12.1231 20 10.1453C19.9972 7.49396 18.9427 4.95204 17.068 3.07729C15.1932 1.20253 12.6513 0.148063 10 0.145264ZM13.6212 12.678C13.6926 12.7494 13.7493 12.8343 13.788 12.9276C13.8267 13.021 13.8466 13.1211 13.8466 13.2222C13.8466 13.3233 13.8267 13.4233 13.788 13.5167C13.7493 13.6101 13.6926 13.6949 13.6212 13.7664C13.5497 13.8379 13.4648 13.8946 13.3715 13.9333C13.2781 13.9719 13.178 13.9918 13.0769 13.9918C12.9759 13.9918 12.8758 13.9719 12.7824 13.9333C12.689 13.8946 12.6042 13.8379 12.5327 13.7664L10 11.2328L7.46731 13.7664C7.39584 13.8379 7.31099 13.8946 7.21762 13.9333C7.12424 13.9719 7.02415 13.9918 6.92308 13.9918C6.82201 13.9918 6.72192 13.9719 6.62854 13.9333C6.53516 13.8946 6.45032 13.8379 6.37885 13.7664C6.30738 13.6949 6.25069 13.6101 6.21201 13.5167C6.17333 13.4233 6.15342 13.3233 6.15342 13.2222C6.15342 13.1211 6.17333 13.021 6.21201 12.9276C6.25069 12.8343 6.30738 12.7494 6.37885 12.678L8.9125 10.1453L6.37885 7.61257C6.23451 7.46823 6.15342 7.27247 6.15342 7.06834C6.15342 6.86421 6.23451 6.66845 6.37885 6.52411C6.52319 6.37977 6.71895 6.29868 6.92308 6.29868C7.12721 6.29868 7.32297 6.37977 7.46731 6.52411L10 9.05776L12.5327 6.52411C12.6042 6.45264 12.689 6.39595 12.7824 6.35727C12.8758 6.31859 12.9759 6.29868 13.0769 6.29868C13.178 6.29868 13.2781 6.31859 13.3715 6.35727C13.4648 6.39595 13.5497 6.45264 13.6212 6.52411C13.6926 6.59558 13.7493 6.68042 13.788 6.7738C13.8267 6.86718 13.8466 6.96727 13.8466 7.06834C13.8466 7.16941 13.8267 7.2695 13.788 7.36287C13.7493 7.45625 13.6926 7.5411 13.6212 7.61257L11.0875 10.1453L13.6212 12.678Z" fill="#A79877"/>
                                    </svg>
                                </div>
                            </div>
                        )
                        })
                    }
                </div>
                {communityData.photos && Array.from(communityData.photos).filter(f => f.type && f.type.includes('video') || (f.image_name  && f.image_name.includes('mp4'))).map((f, index) => (
                    <>{index == 0 && <SectionGalleryVideo>
                        <CloseIcon  onClick={() => {
                                const copyPhotos = Array.from(communityData.photos)
                                copyPhotos.splice(index, 1)
                                setCommunityData({
                                    ...communityData,
                                    ['photos']: [...copyPhotos]
                                })
                                return
                            }}/>
                        <MediaPreview file={f} />
                    </SectionGalleryVideo>}
                    </>))}


                
                    <SectionGalleryImages>
                    {communityData.photos && Array.from(communityData.photos).filter(f => f.type && f.type.includes('image') || !f.location).map((f, index) => (
                        <SectionGalleryImage>
                            <CloseIcon onClick={() => {
                                const copyPhotos = Array.from(communityData.photos).filter(f => f.type && f.type.includes('image') || !f.location)
                                setCommunityData({
                                    ...communityData,
                                    ['photos']: [...copyPhotos.filter(c => c.id != f.id)],
                                    ['deleted_images']: [...communityData.deleted_images, copyPhotos[index]]
                                })
                                return
                            }} />
                            <MediaPreview file={f} />
                        </SectionGalleryImage> 
                    ))}
                    </SectionGalleryImages>

                    <SectionGalleryImages>
                    {communityData.videos && Array.from(communityData.videos).map((f, index) => (
                        <SectionGalleryImage key={index}>
                            <CloseIcon onClick={() => {
                                const copyVideos = Array.from(communityData.videos)
                                setCommunityData({
                                    ...communityData,
                                    ['videos']: [...copyVideos.filter(c => c.id != f.id)],
                                    ['deleted_videos']: [...communityData.deleted_videos, copyVideos[index]]
                                })
                                return
                            }} />
                            <MediaPreview file={f} />
                        </SectionGalleryImage> 
                    ))}
                    </SectionGalleryImages>
                </SectionGalleryMediaWrapper>
                
            </SectionGalleryWrapper>

            <SectionBuilderDetailsContainer>
                <SectionHeader title="Builder Details" />
                <SectionBuilderDetailsWrapper>
                    <SectionBuilderDescriptionWrapper>
                        <SectionBuilderLogoWrapper>
                            <UploadPhoto title="UPLOAD LOGO" 
                             communityFiles={communityData['builder_image'] && Array.from(communityData['builder_image']) || [images.find(img => img.location == 'builder_image')]} 
                            
                                name="builder_image" handleChange={handleChange} />
                        </SectionBuilderLogoWrapper>
                        <textarea placeholder="Builder's Details" value={communityData.builder_description} name="builder_description" onChange={handleChange}></textarea>
                        {_fieldErrors.builder_description && <FieldErrorMessage>{_fieldErrors.builder_description[0]}</FieldErrorMessage>}
                                    
                    </SectionBuilderDescriptionWrapper>
                    <SectionBuilderDetailsContentWrapper>
                        <SectionBuilderDetailsContentWrapper>
                            <SectionBuilderDetailsContent>
                                <SectionBuilderDetailsContentLeftCol>
                                    <textarea placeholder="Builder's Details" name="builder_content" value={communityData.builder_content} onChange={handleChange}></textarea>
                                </SectionBuilderDetailsContentLeftCol>
                                <SectionBuilderDetailsContentRightCol>
                                    <UploadPhoto title="UPLOAD LOGO" 
                                        communityFiles={communityData['builder_content_image'] && Array.from(communityData['builder_content_image']) || [images.find(img => img.location == 'builder_content_image')]} 
                            
                                        name="builder_content_image" handleChange={handleChange} />
                                </SectionBuilderDetailsContentRightCol>
                            </SectionBuilderDetailsContent>
                            </SectionBuilderDetailsContentWrapper>
                            <SectionBuilderDetailsContentText>
                                <textarea placeholder="Builder's Highlight Details" name="builder_highlight_details" value={communityData.builder_highlight_details}  onChange={handleChange}></textarea>
                            </SectionBuilderDetailsContentText>
                    </SectionBuilderDetailsContentWrapper>
                </SectionBuilderDetailsWrapper>
            </SectionBuilderDetailsContainer>
            <Modal
             show={showHighlightsModal}
             size='lg'
             centered
             onHide={() => {
                 //onChange(name, selectedValues)
                 setShowHighlightsModal(!showHighlightsModal)
             }}>
                <ModalHeader>
                    Select highlights
                </ModalHeader>
                <ModalBody>
                    {loading && <Loader/>}
                    {!loading && <Form.Control placeholder="Search highlight" onChange={(e) => setKeyword(e.target.value.toLowerCase())}/>}
                    
                    {!loading && allHighlights.
                        filter(({name}) => name.toLowerCase().includes(keyword))
                        .map(h =>{ return  {...h, value: h.id} }).map( highlight => (
                        <> 
                            <Form.Check
                                checked={selectedHighlights.find( h => highlight.value === h.value)}
                                style={{minHeight: 'auto'}}
                                onChange={(e) => {
                                    const { checked, name, value } = e.target
                                    if(checked) {    
                                        setSelectedHighlights([...selectedHighlights, highlight])
                                    } else {
                                        setSelectedHighlights([...selectedHighlights.filter( h => h.value != value)])
                                    }
                                    return
                                }}
                                label={highlight.name}
                                name={highlight.name}
                                value={highlight.id} />
                        </>
                    ))}
                </ModalBody>
                <ModalFooter>
                <Button variant="primary" onClick={(e) => {
                        e.preventDefault()
                        // onChange(name, selectedValues)
                        setShowHighlightsModal(!showHighlightsModal)
                    }}> Save </Button> 
                </ModalFooter>
            </Modal>
        </EditCommunityContainer> 
    )
}

export default EditCommunityNew
